module.exports = __webpack_public_path__ + "media/images/sosial_media/tw-full-c-43ea1c88dbce9f2f188eef6e7d37f39d.png";